export const blockIconsSocialSportsEsports = (
	<span className='material-symbols-outlined'>sports_esports</span>
);
